import { CampoEditavel } from "@/components/finance/proposta/CampoEditavel";
import { useDefinirCotacaoOmie } from "@/hooks/use-finance-propostas";
import { useToast } from "@/hooks/use-toast";
import { errorMessage } from "@/lib/api-error";
import { formatPercent, simboloMoeda, type Moeda } from "@/utils/money";

/** Cotação fixada na proposta: quando ela é em outra moeda, cada OS sai em reais calculada por este valor. */
export function CampoCotacaoOmie({
  propostaId,
  moeda,
  cotacao,
  cotacaoSugerida,
  destaque,
}: {
  propostaId: string;
  moeda: Moeda;
  cotacao: number | null;
  cotacaoSugerida: number | null;
  destaque?: boolean;
}) {
  const { toast } = useToast();
  const definir = useDefinirCotacaoOmie(propostaId);
  const salvar = (texto: string) => {
    const limpo = texto.trim().replace(/\./g, "").replace(",", ".");
    const valor = limpo === "" ? null : Number(limpo);
    if (valor !== null && (!Number.isFinite(valor) || valor <= 0)) return;
    if (valor === cotacao) return;
    definir.mutate(valor === null ? null : valor.toFixed(4), {
      onError: (error) => toast({ title: "Não foi possível salvar a cotação", description: errorMessage(error), variant: "destructive" }),
    });
  };
  return (
    <CampoEditavel
      id="campo-cotacao_omie"
      label={`Cotação (R$ por ${simboloMoeda(moeda)} 1)`}
      valor={cotacao != null ? formatPercent(cotacao) : ""}
      sufixo="R$"
      inputMode="decimal"
      placeholder={cotacaoSugerida != null ? `Ex.: ${formatPercent(cotacaoSugerida)}` : ""}
      destaque={destaque ?? cotacao == null}
      ajuda="As OS saem em reais calculadas por esta cotação. Ela trava quando a primeira OS vai ao Omie."
      onSalvar={salvar}
    />
  );
}
